<div id="shd-module-icon" class="text-center" [ngClass]="color">
    <fa-icon size="lg" [icon]="moduleIconMap[moduleName]"></fa-icon>
</div>
